import React, { RefObject } from "react";

import "./style.scss";

import {
    Link,
    RouteComponentProps,
    withRouter
} from "react-router-dom";

import {
    AppBar,
    Box,
    Button,
    Menu,
    MenuItem,
    Stack,
    Toolbar,
    Typography,
} from "@mui/material";

import { Trans } from "@lingui/macro";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

import {
    NavLink,
    Redirect,
} from "react-router-dom";
import AuthenticationService from "../../services/authentication-service";

import { HeaderState } from "./models";
import { AccountMenu, BackofficeNavigation, SearchBar } from "components/header";
import { UserType } from "models";

class Header extends React.Component<RouteComponentProps<any>, HeaderState> {

    private readonly selectRef: RefObject<HTMLInputElement> = React.createRef();

    constructor(props: any) {

        super(props);

        this.state = {
            user: null,
            anchorEl: null
        };
    }

    componentDidMount() {

        this.setState(() => ({ user: AuthenticationService.getLocalCurrentUser() }));

        window.addEventListener("user-storage", () => {
            this.setState(() => ({ user: AuthenticationService.getLocalCurrentUser() }));
        });
    }

    private openSelect = (event: React.MouseEvent<HTMLDivElement>) => {
        this.setState(() => ({ anchorEl: this.selectRef.current }));
    }

    private closeSelect = () => {
        this.setState(() => ({ anchorEl: null }));
    };

    render() {

        let backofficeMode = process.env.REACT_APP_BACKOFFICE_MODE === "true"
        let allowProfile = process.env.REACT_APP_ALLOW_PROFILE === "true"

        return (
            <Box component="header">
                {(!this.state.user && process.env.REACT_APP_ALLOW_PUBLIC_CONTENT === "false") && <Redirect to={"/login"} />}
                <AppBar position="fixed"
                    style={{
                        background: process.env.REACT_APP_THIRD_COLOR,
                        boxShadow: "none",
                        padding: "5px",
                        height: "65px"
                    }}>
                    <Toolbar className="nav">
                        <Box mr={5}>
                            <Link to={"/"}>
                                <img src={`${process.env.PUBLIC_URL}/loaded-files/${process.env.REACT_APP_LOGO_FILENAME}`} width={"220px"} alt={"Logo"} />
                            </Link>
                        </Box>

                        {/* Media query small */}
                        <Box ref={this.selectRef} sx={{ display: { lg: 'none', md: 'block', sm: 'block', xs: 'block' } }}>
                            <Stack direction="row" onClick={(event) => this.openSelect(event)} sx={{ cursor: "pointer" }}>
                                <Typography
                                    variant="body2"
                                    textTransform="uppercase"
                                    className="nav-link hover">
                                    <Trans id="bn-service-link">Servizi</Trans>
                                </Typography>
                                {this.state.anchorEl ? <ArrowDropUpIcon fontSize="small" /> :
                                    <ArrowDropDownIcon fontSize="small" />}
                            </Stack>
                            <Menu
                                className="menu-appbar"
                                anchorEl={this.state.anchorEl}
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                open={Boolean(this.state.anchorEl)}
                                onClose={this.closeSelect}
                            >

                                <MenuItem onClick={this.closeSelect}>
                                    <NavLink
                                        to="/"
                                        activeClassName="active-link"
                                        className="nav-link"
                                        isActive={(match, location) => {
                                            return (
                                                location.pathname === "/" ||
                                                location.pathname === "/backoffice/choose-action"
                                            );
                                        }}>
                                        <Trans id="h-nav-home-link">Home</Trans>
                                    </NavLink>
                                </MenuItem>
                                {!this.state.user && !backofficeMode && <MenuItem onClick={this.closeSelect}>
                                    <NavLink
                                        to={"/registration"}
                                        activeClassName="active-link"
                                        className="nav-link">
                                        <Trans id="h-nav-register-link">Registrati</Trans>
                                    </NavLink>
                                </MenuItem>}
                                {(process.env.REACT_APP_SUBSCRIPTION_ENABLED === "true") && !backofficeMode && <MenuItem onClick={this.closeSelect}>
                                    <NavLink
                                        to={"/subscribe"}
                                        activeClassName="active-link"
                                        className="nav-link">
                                        <Trans id="h-nav-info-link">Prezzi e abbonamenti</Trans>
                                    </NavLink>
                                </MenuItem>}
                            </Menu>
                        </Box>

                        {/* Media query large */}
                        <Box sx={{ display: { lg: 'block', md: 'none', sm: 'none', xs: 'none' } }}>
                            <Stack direction="row" spacing={4}>
                                <NavLink
                                    to="/"
                                    activeClassName="active-link"
                                    className="nav-link hover"
                                    isActive={(match, location) => {
                                        return (
                                            location.pathname === "/" ||
                                            location.pathname === "/backoffice/choose-action"
                                        );
                                    }}>
                                    <Trans id="h-nav-home-link">Home</Trans>
                                </NavLink>

                                {(this.state.user === null && process.env.REACT_APP_ALLOW_REGISTRATION) &&
                                    <NavLink
                                        to={"/registration"}
                                        activeClassName="active-link"
                                        className="nav-link">
                                        <Trans id="h-nav-register-link">Registrati</Trans>
                                    </NavLink>
                                }

                                {((process.env.REACT_APP_SUBSCRIPTION_ENABLED === "true" && !backofficeMode) && (this.state.user !== null && process.env.REACT_APP_MANDATORY_SUBSCRIPTION && this.state.user.type === UserType.FREE)) &&
                                    <NavLink
                                        to={"/subscribe"}
                                        activeClassName="active-link"
                                        className="nav-link">
                                        <Trans id="h-nav-info-link">Prezzi e abbonamenti</Trans>
                                    </NavLink>
                                }

                                {backofficeMode && <BackofficeNavigation user={this.state.user} />}
                            </Stack>
                        </Box>

                        <Typography sx={{ flexGrow: 1 }} />

                        {(process.env.REACT_APP_ALLOW_CONTENT_SEARCH === "true") && <SearchBar />}

                        {(this.state.user !== null && allowProfile) &&
                            <AccountMenu backofficeMode={backofficeMode} username={this.state.user.name} />
                        }

                        {this.state.user === null && (<Link to={"/login"}>
                            <Button
                                variant={"text"}
                                color={"primary"}
                                size={"large"}
                                sx={{
                                    fontWeight: "bold",
                                    ml: "15px"
                                }}>
                                <Trans id="header-login-select">Login</Trans>
                            </Button>
                        </Link>)}
                    </Toolbar>
                </AppBar>
            </Box>);
    }
}

export default withRouter(Header); 